export interface AccountPageRequestModel {
    current: number
    size: number
    state: string
    tenantId?: number
}

export interface AccountPageRecord {
    id: number
    balance: number
    currency: string
    state: string
    createTime: string
    updateTime: string
    accountInfoId: number
    cardNumber: string
    cardType?: number
    phone: string
    accountInfoName: string
    identifyNumber: string
    email: string
    bankName: string
}

export interface RechargeAccountParams {
    amount: number
    currency: string
    id: number
    tenantId?: number
}

export interface StateParam {
    id: number
    tenantId?: number
    state: number
}

export interface OpenAccountParams {
    currency: string
    name: string
    type: number
    tenantId?: number
    accountInfoId?: number
    id?: number
    accountInfoName?: string
    balance?: number
    cardNumber?: string
    cardType: number
    bankName?: string
    bankId?: number
    phone?: string
    email?: string
    state?: string
}

export interface AccountParams {
    code: string
    data: boolean
    msg: string
}

export interface RechargeParams {
    amount: number
    currency: string
    id: number
    tenantId?: number
}

export enum AccountState {
    ENABLE = '0',
    DISABLE = '1'
}

export interface BankItem {
    bankName: string
    id: number
    [prop: string]: any
}
export interface ReleaseParams {
    current: number
    size: number
    startDate:any
    endDate:any
}
export interface RepaymentParams {
    current: number
    size: number
    doubleLoan: String
    startDate:any
    endDate:any
}